import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Expertisecards() {
  return <section id="expertisecards" data-nav="light" className="bg-background text-foreground px-6 md:px-10 lg:px-16 py-12 md:py-16">
      <div className="max-w-[1240px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          <div className="bg-card text-card-foreground p-8 md:p-10 border border-border/50 flex flex-col justify-between" style={{
          borderRadius: "4px"
        }}>
            <div>
              <span className="font-mono text-xs uppercase tracking-[0.12em] text-primary font-semibold">
                Metal Roofing
              </span>
              <p className="text-foreground/80 text-base leading-relaxed mt-3 mb-6 font-default">
                Standing seam, metal shingles and stone-coated steel systems built for Calgary winters.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <Button asChild className="rounded-sm">
                <Link to="#start-your-transformation">
                  Request Roofing Estimate &rarr;
                </Link>
              </Button>
              <Button asChild variant="outline" className="rounded-sm">
                <Link to="/RoofingPage">
                  Explore Metal Roofing &rarr;
                </Link>
              </Button>
            </div>
          </div>

          <div className="bg-card text-card-foreground p-8 md:p-10 border border-border/50 flex flex-col justify-between" style={{
          borderRadius: "4px"
        }}>
            <div>
              <span className="font-mono text-xs uppercase tracking-[0.12em] text-primary font-semibold">
                Siding &amp; Cladding
              </span>
              <p className="text-foreground/80 text-base leading-relaxed mt-3 mb-6 font-default">
                James Hardie, LP SmartSide, ACM panels, stone veneer and architectural cladding.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
              <Button asChild className="rounded-sm">
                <Link to="#start-your-transformation">
                  Request Siding Estimate &rarr;
                </Link>
              </Button>
              <Button asChild variant="outline" className="rounded-sm">
                <Link to="/SidingCladdingPage">
                  Explore Siding Options &rarr;
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}